/*    
<summary>
  This functional component "ClientFilterForm" provides form to get data based on filter
  Developer:Aashish Singh, Created Date:20-March-2024
</summary>
<returns>Returns JSX</returns>
*/
import { Field, Form, Formik, useFormikContext } from "formik";
import React from "react";
import { Button, Modal, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import FormikFormTimePicker from "../../../shared-components/FormikFormHandlers/FormikFormTimePicker";
import {
  FreeShiftValidationSchema,
  PublishScheduleValidationSchema,
} from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import LoaderButton from "../../../shared-components/button/loader-button";
import Label from "../../../shared-components/label/label";
import moment from "moment";

interface IProps {
  submitHandler: (values: any) => void;
  onModalClosed: () => void;
  actionInProgress: boolean;
  initialValues: any;
  storeId: number;
}

const FreeShiftForm = (props: IProps) => {
  const { submitHandler, onModalClosed, initialValues, actionInProgress } =
    props;

  const FormObserver: React.FC = () => {
    const { values } = useFormikContext<any>();
    return null;
  };

  return (
    <>
      <Modal className="add-user-modal filter-from " show={true} centered>
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id={`add_free_shift`} />
          </Modal.Title>
          <div onClick={onModalClosed} className="Crossicons">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={FreeShiftValidationSchema}
          onSubmit={async (values: any) => {
            submitHandler({
              values,
              FreeStartTime: moment(values.FreeStartTime, "HH:mm").format(
                "HH:mm:ss"
              ),
              FreeEndTime: moment(values.FreeEndTime, "HH:mm").format(
                "HH:mm:ss"
              ),
            });
          }}
        >
          {({ values }) => (
            <Form className="user-form" noValidate>
              {actionInProgress && <FormLoader loading={actionInProgress} />}
              <FormObserver />
              <Modal.Body>
                <Row className="date-range">
                  <div className="form-group mb-3 row">
                    <div className="col-sm-6">
                      <Label
                        className="label-style"
                        required={false}
                        label="free_start_time"
                      />
                      <Field
                        name="FreeStartTime"
                        as={FormikFormTimePicker}
                      />
                    </div>
                    <div className="col-sm-6">
                      <Label
                        className="label-style"
                        required={false}
                        label="free_end_time"
                      />
                      <Field
                        name="FreeEndTime"
                        as={FormikFormTimePicker}
                      />
                    </div>
                  </div>
                </Row>

                {/* {
                  err &&
                  <div className="error-text text-center w-100">
                  <span data-testid="testError" className="text-danger errorMessage ">
                    <FormattedMessage id="please_select_at_least_1_field" />
                  </span>
                  </div>
                } */}
              </Modal.Body>
              <div className="modal-footer border-0">
                <div className="m-auto">
                  <LoaderButton
                    type="submit"
                    isLoading={actionInProgress}
                    disabled={actionInProgress}
                    text={`add`}
                  />
                  <Button
                    variant="outline-danger" 
                    className="ms-2"
                    onClick={onModalClosed}
                  >
                    <FormattedMessage id="button_cancel" />
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default FreeShiftForm;
